import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, matchPath, useParams } from "react-router-dom";
import { assets } from "../../assets/assets";
import ar from "../../lang/ar";
import en from "../../lang/en";

function DropDownNav({ lang, data }) {
  const translations = lang === "ar" ? ar : en;
  const location = useLocation();
  const navigate = useNavigate();
  const { projectSlug } = useParams();

  const projectName = data?.project?.name || (lang === "ar" ? "المشروع" : "Project");
  const zoneName = data?.name || (lang === "ar" ? "المنطقة" : "Zone");

  // 1. استخراج الـ Params يدوياً وبدقة من الـ URL الحالي
  // هذا يضمن الحصول على الـ id حتى لو فشل الـ matchPath المعقد
  const pathParts = location.pathname.split("/");
  // البحث عن "master-plan" والحصول على الجزء الذي يليه مباشرة
  const mpIndex = pathParts.indexOf("master-plan");
  const zoneIdFromURL = mpIndex !== -1 ? pathParts[mpIndex + 1] : null;

  // 2. المحاولات المحددة للمطابقة
  const matchVilla = matchPath({ path: "/:projectSlug/master-plan/:zoneId/villa/:unitCode/*" }, location.pathname);
  const matchMaster = matchPath({ path: "/:projectSlug/master-plan/:zoneId/*" }, location.pathname);

  // الأولوية للـ zoneId المستخرج من الرابط مباشرة ثم من الـ Matcher
  const zoneIdFromPath = zoneIdFromURL || matchVilla?.params?.zoneId || matchMaster?.params?.zoneId;
  const unitCodeFromPath = matchVilla?.params?.unitCode;

  const [pages, setPages] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activePageKey, setActivePageKey] = useState("jeddahPage");

  useEffect(() => {
    const path = location.pathname;
    let currentPageKey = "jeddahPage";

    if (path === "/" || path === "" || path === `/${projectSlug}`) currentPageKey = "jeddahPage";
    else if (path.includes("/tour/")) currentPageKey = "InteractiveTour";
    else if (path.includes("/villa/")) currentPageKey = "ExploreTour";
    else if (path.includes("/master-plan")) currentPageKey = "gravityPage";

    setActivePageKey(currentPageKey);
    
    let newPages = ["jeddahPage"];
    // إذا وجدنا Zone ID نظهر صفحة الماستر بلان (GravityPage)
    if (zoneIdFromPath) {
      newPages.push("gravityPage");
    }
    if (unitCodeFromPath) {
      newPages.push("ExploreTour");
      if (path.includes("/tour/")) {
        newPages.push("InteractiveTour");
      }
    }
    setPages(newPages);
  }, [location.pathname, zoneIdFromPath, unitCodeFromPath, projectSlug]);

  const renderPageDisplayName = (pageKey, isActiveItem) => {
    if (pageKey === "ExploreTour" && unitCodeFromPath) {
      const label = lang === "ar" ? "فيلا" : "Villa";
      return (
        <div className="d-flex flex-column align-items-start">
          <span style={{ fontWeight: isActiveItem ? "bold" : "normal" }}>
            {label}/{unitCodeFromPath}
          </span>
        </div>
      );
    }

    if (pageKey === "InteractiveTour") {
      return <span>{lang === "ar" ? "جولة تفاعلية" : "Interactive Tour"}</span>;
    }

    if (pageKey === "gravityPage") {
      return (
        <div className="d-flex flex-column align-items-center text-center" style={{ lineHeight: "1.2" }}>
          <span style={{ fontSize: "0.85rem", fontWeight: "bold" }}>{projectName}</span>
          <span style={{ fontSize: "0.75rem", opacity: "0.9" }}>{zoneName}</span>
        </div>
      );
    }

    return <span>{translations[pageKey] || pageKey}</span>;
  };

  const handlePageClick = (pageKey) => {
    setIsMenuOpen(false);
    
    // إذا لم يتوفر projectSlug نستخدم "sadan" كـ fallback أو نتركه فارغاً
    const slug = projectSlug || "sadan";

    if (pageKey === "jeddahPage") {
      navigate(`/${slug}`);
    } else if (pageKey === "gravityPage" && zoneIdFromPath) {
      navigate(`/${slug}/master-plan/${zoneIdFromPath}`);
    } else if (pageKey === "ExploreTour" && zoneIdFromPath && unitCodeFromPath) {
      navigate(`/${slug}/master-plan/${zoneIdFromPath}/villa/${unitCodeFromPath}`);
    } else if (pageKey === "InteractiveTour" && zoneIdFromPath && unitCodeFromPath) {
      navigate(`/${slug}/master-plan/${zoneIdFromPath}/villa/${unitCodeFromPath}/tour/index.html`);
    }
  };

  return (
    <div className="dropdown dropdown-nav m-0 px-0" dir={lang === "ar" ? "rtl" : "ltr"}>
      <button
        className="btn dropdown-toggle col-12 d-flex align-items-center justify-content-between"
        type="button"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{ padding: "5px 10px" }}
      >
        <div className="text-truncate" style={{ maxWidth: "85%" }}>
          {renderPageDisplayName(activePageKey, true)}
        </div>
        <img
          src={assets.arrowDropdownWhite}
          className={`filter-icon arrow-icon ${isMenuOpen ? "open" : ""}`}
          alt="arrow"
        />
      </button>

      <ul className={`dropdown-menu dropdown-slide col-12 ${isMenuOpen ? "show" : ""}`}>
        {pages.map((pageKey, index) => (
          <li key={index}>
            <button
              className={`dropdown-item ${activePageKey === pageKey ? "active" : ""}`}
              onClick={() => handlePageClick(pageKey)}
            >
              {renderPageDisplayName(pageKey, activePageKey === pageKey)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DropDownNav;